import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Context } from "../../state/context";
import { Link } from "react-router-dom";

import KeyItemStatus from '../key-item-status/key-item-status.component';

import useGetTranslationValues from '../../api/translationValues';
import useFetch from '../../api/fetch';

import './translation-keys-right-panel.styles.scss';

const SORT_OPTIONS = [
    {
        label: 'Language',
        value: 'language'
    },
    {
        label: 'Length',
        value: 'length'
    }
];

const SORT_DIRECTION = {
    'ASC':0,
    'DESC':1,
}

export default function TagsRightPanel() {
    const { state, dispatch } = useContext(Context);
    const history = useHistory();

    const getTranslationValues = useGetTranslationValues();
    const fetch = useFetch();

    const [values, setValues] = useState([]);
    const [sortOption, setSortOption] = useState(SORT_OPTIONS[0].value);
    const [sortDirection, setSortDirection] = useState(SORT_DIRECTION.ASC);
    const [copiedIndex, setCopiedIndex] = useState(-1);
    const [languages, setLanguages] = useState([]);
    const [addedLanguages, setAddedLanguages] = useState([]);
    const [bulkEdits, setBulkEdits] = useState({});
    const [showAddLanguages, setShowAddLanguages] = useState(false);
    const [bulkEditMode, setBulkEditMode] = useState(false);
    const [bulkEditLoading, setBulkEditLoading] = useState(false);
    const [error, setError] = useState(null);
    const [sendingNotification, setSendingNotification] = useState(false);
    const [exportAllBtnStatus, setExportAllBtnStatus] = useState(true);

    useEffect(() => {
        (async () => {
            const languageList = await fetch(`/api/language/list`).then(x => x.json());
            setLanguages(languageList);
        })();
    }, []);

    useEffect(() => {
        setShowAddLanguages(addedLanguages.length > 0);
    }, [addedLanguages]);

    useEffect(() => {
        refreshValues(values);
    }, [languages]);

    useEffect(() => {
        (async () => {
            let values = await getTranslationValues(state.activeTranslationKey.id);
            refreshValues(values);
        })();
    }, [state.activeTranslationKey]);

    useEffect(() => {
      (async () => {
        let values = await getTranslationValues(state.activeTranslationKey.id);
        refreshValues(values);
        dispatch({ type: 'SET_REFRESH_TRANSLATIONS', translationStatus: false });
      })();
    }, [state.translationStatus, languages]);

    useEffect(() => {
        const sortedValues = sortValues(values, sortOption);
        setValues(Array.from(sortedValues));
    }, [sortOption, sortDirection, languages]);


  useEffect(() => {
    const urlHash = history.location.hash.replace("#",'');
    const urlParts = urlHash.split('=');
    if(urlParts[0] === 'languageTag' && !!urlParts[1]) {
      //search the translationValue object for the given languageTag
      const translationValue = values.find((item) => item.language_tag === urlParts[1]);
      if(translationValue) {
        keyClick(translationValue)
      }
    }
  }, [values]);

    const notifyTranslators =  async () => {
        setSendingNotification(true);
        let result = await fetch(`/api/key/force-notification/${state.activeTranslationKey.id}`).then(x => x.json());
        if (result.success) {
            alert(result.message)
        } else {
            alert(result.error)
        }
        setSendingNotification(false);
    }

    const refreshValues = (values) => {
        const activeLanguages = values.map(({language_tag}) => language_tag);
        const inactiveLanguages = languages.filter(l => !activeLanguages.includes(l.tag));
        inactiveLanguages.forEach((inactiveLanguage) => {
            values.push({
                id: -1,
                language_tag: inactiveLanguage.tag,
                status: -1,
                text: '',
                translation_key_id: state.activeTranslationKey.id
            });
        });

        if (state.language) {
            const { id, text } = state.activeTranslationKey;
            const status = state.activeTranslationKey.key_status;
            dispatch({ type: 'SET_ACTIVE_KEY', activeKey: { id, text, status } });
        }

        let sortedValues = sortValues(values, sortOption);
        setValues(sortedValues);
    }

    const toggleSortDirection = () => {
        if(sortDirection === SORT_DIRECTION.ASC) {
            setSortDirection(SORT_DIRECTION.DESC);
        } else {
            setSortDirection(SORT_DIRECTION.ASC);
        }
    }

    const handleBulkEditChange = (translationValueId, translationValueText) => {
        let localBulkEdits = {...bulkEdits};
        localBulkEdits[translationValueId] = translationValueText;
        setBulkEdits({...localBulkEdits});
    }

    const handleAddLanguage = (e) => {
        const lang = e.target.value;
        const isChecked = e.target.checked;
        let addedLangs = [...addedLanguages];
        if (isChecked) {
            addedLangs.push(lang);
        } else {
            let index = addedLangs.indexOf(lang);
            addedLangs.splice(index, 1);
        }

        setAddedLanguages(addedLangs);
    }

    const submitBulkEdits = async (e) => {
        e.preventDefault();
        setBulkEditLoading(true);

        var data = [];

        for (let k in bulkEdits) {
            if (typeof bulkEdits[k] !== 'function') {
                data.push({
                    'id': k,
                    'text': bulkEdits[k]
                })
            }
        }

        const formData = new FormData();
        formData.append('translationValues', JSON.stringify(data));

        const result = await fetch(`/api/key/bulk-edit`, {
            method: "POST",
            body: formData
        }).then(res => res.json());

        if (result.success) {
            let values = await getTranslationValues(state.activeTranslationKey.id);
            refreshValues(values);
            setBulkEditMode(false);
            setBulkEdits({});
            setError(null);
            setBulkEditLoading(false);
        } else {
            setError({ invalid: true, message: result.error });
            setBulkEditLoading(false);
        }
    }

    const submitAddLanguages = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('languages', JSON.stringify(addedLanguages));

        const result = await fetch(`/api/key/create-languages/${state.activeTranslationKey.id}`, {
            method: "POST",
            body: formData
        }).then(res => res.json());

        if (result.success) {
            setShowAddLanguages(false);
            setError(null);
        } else {
            setError({ invalid: true, message: result.error });
        }
        setAddedLanguages([]);
        dispatch({ type: 'SET_REFRESH_TRANSLATIONS', translationStatus: true });
        window.$('#confirm-add-new-language').modal("hide");
    }

    const displayConfirmationPopup = () => {
      window.$('#confirm-add-new-language').modal("show");
    }

    const exportLocalizations = async(e) => {
      const exportType = e.target.value;
      setExportAllBtnStatus(false);
      if(!exportType) return;
      const result = await fetch(`/api/value/export/${state.activeTranslationKey.id}/${exportType}`, {
          method: "POST",
          body: {}
        })
        .then(res => res.blob())
        .then(res => {
          const url = new Blob([res],{type:'application/text'});
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(url);
          link.setAttribute('download', `${state.activeTranslationKey.text}.${exportType}`);
          document.body.appendChild(link);
          link.click();
          setExportAllBtnStatus(true);
        });
    }

    const approveAllTranslations = async(e) => {
      e.preventDefault();
      const result = await fetch(`/api/value/approve-all-translations/${state.activeTranslationKey.id}`, {
        method: "POST",
        body: {}
      }).then(res => res.json());
       if (result.success) {
         dispatch({ type: 'SET_REFRESH_TRANSLATIONS', translationStatus: true });
       } else {
         setError({ invalid: true, message: result.error });
       }
      window.$('#confirm-bulk-approval').modal("hide");
    }
    const copyToClipboard = (e, value, index) => {
        e.preventDefault();
        navigator.clipboard.writeText(value);
        setCopiedIndex(index);

        setTimeout(() => {
            setCopiedIndex(-1);
        }, 1000);
    }

    const keyClick = (translationValue) => {
        const { id, text } = state.activeTranslationKey;
        const status = state.activeTranslationKey.key_status;
        dispatch({ type: 'SET_LANGUAGE', language: translationValue.language_tag });
        dispatch({ type: 'SET_ACTIVE_KEY', activeKey: { id, text, status } });
        window.location.hash = 'languageTag=' + translationValue.language_tag;
    };

    const sortValues = (values, criteria) => {
        switch(criteria) {
            case 'language':
                values.sort((a, b) => {
                    if(sortDirection === SORT_DIRECTION.ASC) {
                        if(a.language_tag < b.language_tag) return -1;
                        if(a.language_tag > b.language_tag) return 1;
                    } else {
                        if(a.language_tag < b.language_tag) return 1;
                        if(a.language_tag > b.language_tag) return -1;
                    }

                    return 0;
                });
                return values;
            case 'length':
                values.sort((a, b) => {
                    if(sortDirection === SORT_DIRECTION.ASC) {
                        return a.text.length - b.text.length;
                    } else {
                        return b.text.length - a.text.length;
                    }
                });
                return values;
        }
    }

    return (
      <>
        <div className="d-flex flex-column col">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h6>Translations for key: {state.activeTranslationKey.text}</h6>
                {sendingNotification && <span className='notification-loader'>Sending ...</span>}
                {!sendingNotification && <button className="btn btn-mondly btn-blue" onClick={notifyTranslators}><i className="far fa-bell d-inline-block mr-2"></i> Notify translators</button>}
            </div>
            {showAddLanguages && <div className="d-flex mb-3">
                <button className="btn btn-mondly btn-blue" onClick={() => displayConfirmationPopup()}>Add languages</button>
                {error && <div><small className="text-danger">{error.message}</small></div>}
            </div>}
            <div className="row mb-3">
                <div className="col-6 align-items-center justify-content-between">
                    {!bulkEditMode &&
                      <>
                        <button className="btn btn-mondly btn-blue" onClick={ e => setBulkEditMode(true)}>Bulk edit</button>&nbsp;
                        <button className="btn btn-mondly btn-blue" data-toggle="modal" data-target="#confirm-bulk-approval">Approve all</button>&nbsp;
                        <select className="btn btn-blue" onChange={(e) => exportLocalizations(e)}>
                          <option value="" selected={exportAllBtnStatus}>Export all </option>
                            <option value="json" key="json">JSON file</option>
                            <option value="csv" key="csv">CSV file</option>
                        </select>
                      </>
                    }
                    {bulkEditMode && <button className="btn btn-mondly btn-blue" onClick={ submitBulkEdits }>Save bulk {bulkEditLoading && <span className="loading-marker ml-2"></span>}</button>}
                </div>
                <div className="col-6 d-flex align-items-center justify-content-end">
                    <label className="mb-0 font-weight-bold" htmlFor="values-sort">Sort by: </label>
                    <div className="d-inline-block">
                        <div className="custom-control mr-4 d-inline-block">
                            <select className="custom-select" id='values-sort' onChange={(e) => setSortOption(e.target.value)}>
                                {SORT_OPTIONS.map((option, index) => (
                                    <option key={index} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>
                        <button title={`${sortDirection === SORT_DIRECTION.ASC ? 'desc' : 'asc'}`} className='btn btn-blue' onClick={toggleSortDirection}><i className={`fas ${sortDirection === SORT_DIRECTION.ASC ? 'fa-sort-amount-up-alt' : 'fa-sort-amount-down-alt'}`}></i></button>
                    </div>
                </div>


            </div>
            <div className="keys-column">
                {values.map((translationValue, index) => {
                    if (translationValue.id > 0) {
                        if (!bulkEditMode)
                            return (
                                <div
                                    onClick={(e) => keyClick(translationValue)}
                                    className={`translation-value translated d-flex align-items-center justify-content-between px-3 py-2 mb-2 text-decoration-none ${translationValue.language_tag == state.language ? 'active' : ''}`}
                                    key={index}>
                                        <span>
                                          <span className='font-weight-bold font-family-monospace mr-1'>{translationValue.language_tag}:</span>
                                          <span dangerouslySetInnerHTML={{ __html:translationValue.text}}></span>
                                        </span>
                                        <span className="d-flex align-items-center">
                                            {index != copiedIndex && <i className="far fa-clipboard h5 text-muted mb-0 mr-3" title="Copy to clipboard" onClick={(e) => copyToClipboard(e, translationValue.text, index)}></i>}
                                            {index == copiedIndex && <i className="fas fa-clipboard-check h5 text-success mb-0 mr-3 copy-success" title="Copy to clipboard" onClick={(e) => copyToClipboard(e, translationValue.text, index)}></i>}
                                            <span>({translationValue.text ? translationValue.text.length : 0})</span>
                                            <KeyItemStatus className="ml-2" status={translationValue.status} />
                                        </span>
                                </div>
                            )
                        else
                            return (
                                <div
                                    className={`translation-value translated d-flex align-items-center justify-content-between px-3 py-2 mb-2 text-decoration-none ${translationValue.language_tag == state.language ? 'active' : ''}`}
                                    key={index}>
                                        <span><span className='font-weight-bold font-family-monospace mr-1'>{translationValue.language_tag}:</span></span>
                                        <div className="form-group w-100">
                                            <textarea className="form-control" rows="2" value={bulkEdits[translationValue.id] || translationValue.text} onChange={e => handleBulkEditChange(translationValue.id, e.target.value)}></textarea>
                                        </div>
                                </div>
                            )
                    } else {
                        return (
                            <div
                                className={'translation-value d-flex align-items-center justify-content-between px-3 py-2 mb-2 text-decoration-none bg-light'}
                                key={index}>
                                    <span><span className='font-weight-bold font-family-monospace mr-1'>{translationValue.language_tag}</span></span>
                                    <span className="d-flex align-items-center">
                                        <input type="checkbox" name="addLanguages" value={translationValue.language_tag} onChange={handleAddLanguage}/>
                                    </span>
                            </div>
                        )
                    }
                })}
            </div>
        </div>
        <div className="modal fade" id="confirm-bulk-approval" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <p>Are you sure you want to approve all these translations?</p>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-mondly btn-outline-blue" data-dismiss="modal" aria-label="Close">Cancel</button>
                <button className="btn btn-mondly btn-blue" onClick={(e) => approveAllTranslations(e)}>Approve</button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="confirm-add-new-language" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-lg modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <p>
                      Are you sure you want to submit this text to translators?
                    </p>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-mondly btn-outline-blue" data-dismiss="modal" aria-label="Close">Cancel</button>
                <button className="btn btn-mondly btn-blue" onClick={(e) => submitAddLanguages(e)}>Send</button>
              </div>
          </div>
        </div>
      </div>

      </>
    )

}
